import React, { useCallback, useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { GetCommanWay, ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Img } from "components";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { object } from "yup";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import { roles } from "utils/constant";
import { ArrowDownIcon, ArrowsUpDownIcon, ArrowUpIcon } from "@heroicons/react/24/outline";
import Spinner from "utils/Spinner";
import { Table, TableHeader, TableBody, TableColumn, TableRow, TableCell } from "@heroui/table";
import { Chip } from "@nextui-org/react";

const GeoList: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const navigator = useNavigate();
  const [tableData, setTableData] = useState<any>([]);

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = localStorage.getItem("auth") ? JSON.parse(localStorage.getItem("auth")) : {};
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});
  const tableRef = useRef(null);

  const { error, isFetching, isError, isFetched, isLoading, refetch } = useQuery(
    ["_geo_user_list".replaceAll("/", "_")],
    () => GetCommanWay("/geo-map/api/0/last", {}, {}),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          let tableData = [...(data?.data || [])];
          setTableData(tableData);
        }
      },
    }
  );

  return (
    <>
      {isLoading && <Spinner />}

      <h1 className="text-center mb-1 mt-2 text-lg font-bold font-inter underline ">Users List</h1>

      <div className="px-4">
        <div className="flex font-inter">
          <Table
            isStriped
            isHeaderSticky
            removeWrapper
            className="w-full text-sm text-left text-gray-500 "
            aria-label="collection table"
            classNames={{
              td: "group-data-[odd=true]/tr:before:bg-blue-100", // light blue
            }}
          >
            <TableHeader className="text-gray-700 uppercase bg-gray-50 sticky top-0">
              <TableColumn className="text-sm px-2 py-1 text-center">ID</TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">Date</TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">Point</TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">Last Location</TableColumn>
            </TableHeader>

            <TableBody>
              {tableData.map((rd, j) => {
                return (
                  <>
                    <TableRow className={`text-black-900`} key={"tbl-asd-" + j}>
                      <TableCell>{rd.username}</TableCell>
                      <TableCell className="border-x border-gray-300">
                        <span className="text-black-900">{moment(rd.isolocal).format("DD/MM/YYYY HH:mm")}</span>
                      </TableCell>
                      <TableCell className="border-x border-gray-300">
                        <Link to={`/geo/map-timeline?u=${rd.username}`}>Track</Link>
                      </TableCell>
                      <TableCell className="border-x border-gray-300">
                        <a target="_blank" href={`https://google.com/maps?q=${rd.lat || "0.0"},${rd.lon || "0.0"}`}>
                          {rd.lat || "-"},{rd.lon}
                        </a>
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </div>
    </>
  );
};

export default GeoList;
